import React, { PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
    name: string;
}>;

export const ProTab = ({ children }: Props) => {
    return <>{children}</>;
};
